import script from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\BtnWhatsapp\\WhatsappIcon.vue?type=script"
export * from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\BtnWhatsapp\\WhatsappIcon.vue?type=script"
import { render } from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\BtnWhatsapp\\WhatsappIcon.vue?type=template"

script.render = render
export default script